import { setBuilderToolbar } from '../../../../../Template/config/components/selection/SetBuilder'

export default {
  ...setBuilderToolbar,
  enableExcludeNonNormFilters: {
    ad: true,
    norm: true
  },
  exportButtons: {
    ad: {
      data: true,
      media: true
    },
    norm: {
      data: true,
      media: true
    }
  },
  sortOptions: [
    {
      "value": -1,
      "label": "Alpha Order by Ad Code",
      "field": "ad_code",
      "selected": false
    },
    {
      "value": 1,
      "label": "Ad Effect Score",
      "selected": true,
      "dataFormat": ".,0"
    },
    {
      "value": 3,
      "label": "Lift to Consideration",
      "selected": false
    },
    {
      "value": 2,
      "label": "Lift to Impression",
      "selected": false
    },
    {
      "value": 5,
      "label": "Net Actions",
      "selected": false
    },
    // {  // TODO
    //   "value": 151,
    //   "label": "Likeability",
    //   "selected": false
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/app/configuration/Optimum/config/components/selection/SetBuilder/setBuilderToolbar.js